import { Maybe } from "rsl-api-106/lib/types";

import { CurrencyCodeEnum } from "../types/enum";

const baseCode = "EUR";

const getCurrencySymbol = (currencyCode?: Maybe<String>): string => {
  switch ((currencyCode ? currencyCode : baseCode).toUpperCase()) {
    case "EUR":
      return CurrencyCodeEnum.EUR;
    case "DOL":
      return CurrencyCodeEnum.DOL;
    default:
      return CurrencyCodeEnum.EUR;
  }
};

export { getCurrencySymbol };
